import type { SoundDefinition } from '@web-kits/audio';

export const SUGGESTION_TAB_ALERTS_STORAGE_KEY_PREFIX = 'suggestion_tab_alerts';
export const SUGGESTION_TAB_ALERTS_KEY_SEPARATOR = ':';
export const SUGGESTION_TAB_ALERTS_LOCK_PREFIX = 'suggestion_tab_alerts_lock';

export const WINDOW_FOCUS_EVENT = 'focus';

export const SUGGESTION_SOUND_THROTTLE_MS = 10_000;

export const SUGGESTION_TAB_TITLE_MAX_DISPLAY_COUNT = 9;
export const SUGGESTION_TAB_TITLE_OVERFLOW_SUFFIX = '+';
export const SUGGESTION_TAB_TITLE_I18N_KEY = 'suggestionTabAlerts.tabTitle';

export const FAVICON_PATH = '/favicon.ico';
export const FAVICON_LINK_REL = 'icon';
export const FAVICON_BADGE_CANVAS_SIZE = 64;
export const FAVICON_BADGE_DOT_COLOR = '#0CCF7C';
export const FAVICON_BADGE_RING_COLOR = '#FFFFFF';
export const FAVICON_BADGE_LOGO_INSET_RATIO = 0.1875;
export const FAVICON_BADGE_DOT_RADIUS_RATIO = 0.133;
export const FAVICON_BADGE_RING_WIDTH_RATIO = 0.039;
export const FAVICON_BADGE_IMAGE_TYPE = 'image/png';

export const AUDIO_UNLOCK_EVENTS = ['pointerdown', 'keydown'] as const;
export const AUDIO_CONTEXT_RUNNING_STATE = 'running';

// "minimal" patch by Raphael Salaja (MIT), @web-kits/audio
export const MINIMAL_NOTIFICATION_SOUND: SoundDefinition = {
  layers: [
    {
      source: { type: 'sine', frequency: 660 },
      envelope: { attack: 0, decay: 0.05, sustain: 0, release: 0.02 },
      gain: 0.1,
    },
    {
      source: { type: 'sine', frequency: 880 },
      envelope: { attack: 0, decay: 0.04, sustain: 0, release: 0.015 },
      delay: 0.08,
      gain: 0.08,
    },
  ],
};

export const ATTENTION_TAB_TITLE_I18N_KEY = 'attentionTabAlerts.tabTitle';
export const APPROVAL_ALERT_KEY_PREFIX = 'approval:';
export const ASK_ALERT_KEY_PREFIX = 'ask:';
